import { DateTime, Settings } from 'luxon'

Settings.defaultLocale = 'es'

export default DateTime
